// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1M7z1","badges":"styles_badges__2mlHN"};